import { AuthService } from './../../shared/services/auth.service';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DashboardService } from './../../shared/services/dashboard.service';
import * as moment from 'moment';
import { Moment } from 'moment';

@Component({
  selector: 'app-calls-report',
  templateUrl: './calls-report.component.html',
  styleUrls: ['./calls-report.component.scss'],
})
export class CallsReportComponent implements OnInit, OnDestroy {

  month: number = moment().month();
  year: number = moment().year();
  error = null;
  searchClicked = false;
  loading = false;
  minDate = moment().subtract(90, 'days');
  maxDate = moment();

  get totalSent(): number {
    return this.result.reduce((prev, next) => prev + next.quantity, 0);
  }

  result: any[] = [];
  subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private dashboardService: DashboardService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.queryParams.subscribe(params => {
        this.month = +params.month;
        this.year = +params.year;

        this.searchClicked = !!(this.month && this.year);

        this.listDailySent();
      }),

      this.authService.userChanged.subscribe(() => this.listDailySent())
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  listDailySent(): void {
    if (this.searchClicked) {
      this.loading = true;
      this.subscriptions.push(
        this.dashboardService.callsReport(this.month, this.year)
          .pipe(finalize(() => this.loading = false))
          .subscribe(result => this.result = result)
      );

      return;
    }

    // Sem mês escolhido não há chamada: ligar a flag aqui deixaria o esqueleto
    // brilhando para sempre numa tela que não está esperando nada.
    this.loading = false;
    this.result = [];
  }

  search(): void {
    const date = new Date();
    this.error = null;

    if ((!this.month && this.month !== 0) || !this.year) {
      this.error = 'Mês e Ano são obrigatórios';
      return;
    } else if (+this.year > date.getFullYear()) {
      this.error = 'O ano deve ser menor que o atual';
      return;
    } else if (+this.year === date.getFullYear() && +this.month > date.getMonth() + 1) {
      this.error = 'O mês não pode ser posterior ao atual';
      return;
    }

    const queryParams = {
      month: this.month + 1,
      year: this.year
    };

    this.router.navigate(['/calls-report'], { queryParams });
  }

  reset(): void {
    this.error = null;
  }

  onMonthAndYear(monthAndYear: Moment): void {
    this.month = monthAndYear.month();
    this.year = monthAndYear.year();
    this.search();
  }
}
